import moment from 'moment';
import { lsFilters } from 'ls-vue-common';
import _ from 'lodash';

function generateLtrsStartDateOptions() {
  // logic taken from my. order-service.controller ln75
  const startDates = [];
  const thisMonday = moment().day(1);
  // check if we are between thu at 5pm and sunday at midnight, if so move monday to next week
  const firstWeek = moment().isBetween(
    moment('17:00', 'HH:mm').day(4),
    moment('24:00', 'HH:mm').day(7)
  )
    ? 14
    : 7;
  startDates.push(thisMonday.add(firstWeek, 'days').format('YYYY-MM-DD'));
  startDates.push(thisMonday.add(7, 'days').format('YYYY-MM-DD'));
  startDates.push(thisMonday.add(7, 'days').format('YYYY-MM-DD'));

  return _.map(startDates, (date) => {
    return {
      value: date,
      label: `Week of ${lsFilters.date({ date })}`,
    };
  });
}

//eslint-disable-next-line import/prefer-default-export
export const lsOrderServicesHelpers = {
  generateLtrsStartDateOptions,
};
